import { cn } from '../../../lib/cn';

export function GoalDiff({ gd, className }: { gd: number; className?: string }) {
  const color = gd > 0 ? 'text-accent-ink' : gd < 0 ? 'text-danger' : 'text-ink2';
  const label = gd > 0 ? `+${gd}` : gd < 0 ? `−${Math.abs(gd)}` : '0';
  return <span className={cn('num text-center font-bold', color, className)}>{label}</span>;
}

export function Legend({ color, label }: { color: string; label: string }) {
  return (
    <span className="flex items-center gap-1.5 text-[10px] font-semibold text-ink2">
      <span className="h-2.5 w-[3px] rounded-full" style={{ background: color }} />
      {label}
    </span>
  );
}
